import API from '../../api';

const API_URI = '/v1/mypage';

export default {
  get(params) {
    return API.request('get', API_URI, params);
  }
}
